// Small DOM helpers for managing <head> meta / link tags in the SPA.
export function setMeta({ name, property }, content) {
  const selector = name
    ? `meta[name="${name}"]`
    : `meta[property="${property}"]`;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    if (name) tag.setAttribute("name", name);
    if (property) tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// Inject a stylesheet <link> once (idempotent). Used to lazily load a
// locale-specific webfont (e.g. Noto Sans SC for Simplified Chinese) only when
// that locale becomes active.
export function ensureStylesheet(id, href) {
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}
